<template>
  <div :class="formSectionClass">
    <slot name="before"/>
    <div class="container">
      <div class="block">
        <h2>{{ title }}</h2>
        <div class="form-error-head text-danger" v-if="hasErrors">{{ errorMessage }}</div>
        <slot name="step-icon">
          <step-one-icon/>
        </slot>
        <slot name="section-header"/>
        <hr/>
        <div class="padding40">
          <slot/>
        </div>
        <slot name="section-footer"/>
      </div>
    </div>
    <slot name="after"/>
  </div>
</template>

<script>
import StepOneIcon from './step-icons/StepOneIcon.vue'

export default {
  name: 'FormSections',

  props: {
    title: String,

    isFirstSection: {
      type: Boolean,
      default: false
    },

    hasErrors: {
      type: Boolean,
      default: false
    },

    errorMessage: {
      type: String,
      default: 'Заполните все поля'
    }
  },

  components: {
    StepOneIcon
  },

  computed: {
    formSectionClass () {
      const classes = [
        'form-section'
      ]

      if (this.isFirstSection) {
        classes.push('first-form-section')
      }

      return classes
    }
  }
}
</script>
